// Cuenta del agente en la pasarela de voz (voz/api/servidor.mjs). El agente da los datos de su extension de 3CX;
// el servidor crea su cuenta y le devuelve solo el usuario y la clave de la pasarela (la de 3CX no vuelve).
import { request } from './http';

export type EstadoRegistro = 'REGISTRADO' | 'RECHAZADO' | 'SIN_REGISTRO' | 'CONECTANDO';

export type CuentaVoz =
  | { configurado: false }
  | { configurado: true; usuario: string; clave: string; fqdn: string; extension: string; authId: string; estado: EstadoRegistro };

export type DatosExtension = { fqdn: string; extension: string; authId: string; clave: string };

export const miCuentaVoz = () => request<CuentaVoz>('/voz/api/agente');

export const configurarCuentaVoz = (d: DatosExtension) => request<CuentaVoz>('/voz/api/agente', { method: 'POST', body: d });

export const reintentarRegistroVoz = () => request<{ estado: EstadoRegistro }>('/voz/api/agente/reintentar', { method: 'POST' });

export const borrarCuentaVoz =() => request<CuentaVoz>('/voz/api/agente', { method: 'DELETE' });

// Extension de 3CX de cada agente de la empresa (para mostrar su nombre en llamadas y reportes).
export const agentesVoz = () => request<{ email: string; extension: string }[]>('/voz/api/agentes');

export const TEXTO_ESTADO: Record<EstadoRegistro, string> = {
  REGISTRADO: 'Registrado en tu 3CX',
  RECHAZADO: '3CX rechazó los datos: revisa la extensión, el Auth ID y la contraseña',
  SIN_REGISTRO: 'Sin registro en 3CX: el CRM se registra solo mientras lo tienes abierto',
  CONECTANDO: 'Conectando con tu 3CX…',
};
